import { Dispatch, SetStateAction } from "react";
import classNames from "classnames";
import { Button } from "components/atoms/Button";
import { DropDown } from "components/atoms/DropDown";
import { decodeToken } from "utils/functions/decodeToken";
import { getOfficeHoursDisplayName } from "utils/functions/getOfficeHoursDisplayName";
import { ACT_TEST_TYPE, SAT_TEST_TYPE } from "utils/constants";
import "./index.scss";

interface SelectedBtnState {
  [key: string]: boolean;
  "1": boolean;
  "2": boolean;
  "3": boolean;
  "4": boolean;
}

interface IProps {
  selectedBtn: SelectedBtnState;
  setSelectedBtn: Dispatch<SetStateAction<SelectedBtnState>>;
  setDropDownSelection?: Dispatch<
    SetStateAction<null | string | { [key: number]: string }>
  >;
  selectedOption?: null | string | { [key: number]: string };
  firstFilterLabel?: string;
  secondFilterLabel?: string;
  thirdFilterLabel?: string;
  forthFilterLabel?: string;
  isAlert?: boolean;
}

export const HomePageFilterButtonSection = ({
  selectedBtn,
  setSelectedBtn,
  setDropDownSelection,
  selectedOption,
  firstFilterLabel,
  secondFilterLabel,
  thirdFilterLabel,
  forthFilterLabel,
  isAlert,
}: IProps) => {
  const handleOnClick = (btnNumber: number) => {
    setSelectedBtn({
      "1": false,
      "2": false,
      "3": false,
      "4": false,
    });
    setSelectedBtn((prevSelectedBtn: SelectedBtnState) => ({
      ...prevSelectedBtn,
      [btnNumber.toString()]: true,
    }));
  };
  const payload = decodeToken();

  return (
    <div className={classNames("filter-btn-section-wrapper")}>
      <div className={classNames("filter-btn-section")} id="filter-btn-section">
        <Button
          label={firstFilterLabel ? firstFilterLabel : "View All"}
          type="filter"
          isSelected={selectedBtn["1"]}
          icon={false}
          onClick={() => handleOnClick(1)}
        />
        <Button
          label={secondFilterLabel ? secondFilterLabel : "Classes"}
          type="filter"
          isSelected={selectedBtn["2"]}
          icon={false}
          onClick={() => handleOnClick(2)}
        />
        <Button
          label={thirdFilterLabel ? thirdFilterLabel : "Tests"}
          type="filter"
          isSelected={selectedBtn["3"]}
          icon={false}
          onClick={() => handleOnClick(3)}
        />

        {payload &&
        payload.hasOwnProperty("showsupplementalsessions") &&
        payload.showsupplementalsessions.toLowerCase() === "true" ? (
          <Button
            label={
              forthFilterLabel
                ? forthFilterLabel
                : `${getOfficeHoursDisplayName(payload?.testtype || "")} Sessions`
            }
            type="filter"
            isSelected={selectedBtn["4"]}
            icon={false}
            onClick={() => handleOnClick(4)}
          />
        ) : null}
      </div>
      {!isAlert && (
        <div className={classNames("drop-down-section")} id="drop-down-section">
          <DropDown
            data={[
              "Recent and Upcoming Sessions",
              "Past Sessions",
              "All Sessions",
            ]}
            setDropDownSelection={setDropDownSelection}
            defaultSelected={selectedOption}
          />
        </div>
      )}
    </div>
  );
};
